<div class="expense-tracker" [class.expense-tracker--small]="size === 'small'" (click)="openModal()">
  <!-- Header -->
  <div class="expense-tracker__header">
    <div class="header-left">
      <div class="expense-tracker__title">{{ title }}</div>
      <div class="pagination-indicator" *ngIf="expenses.length > visibleItemsCount">
        {{ paginationText }}
      </div>
    </div>

    <div class="header-right">
      <!-- Navigation -->
      <div class="nav-controls" *ngIf="expenses.length > visibleItemsCount">
        <div class="nav-btn" [class.disabled]="!canGoPrev" (click)="canGoPrev && prev(); $event.stopPropagation()">
          <img src="assets/icons/arrow-white-left.svg" alt="Prev" />
        </div>
        <div class="nav-btn" [class.disabled]="!canGoNext" (click)="canGoNext && next(); $event.stopPropagation()">
          <img src="assets/icons/arrow-white-right.svg" alt="Next" />
        </div>
      </div>

      <!-- Edit Pencil (only in edit mode) -->
      <ng-container *ngIf="isEditMode">
        <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
          cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
          <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
        </div>
        <!-- Size Dropdown -->
        <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
          [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
          [toggleSizeDropdown]="toggleSizeDropdown">
        </app-widget-edit>
      </ng-container>
      <ng-container *ngIf="isAddMode">
        <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
          (click)="addWidget.emit(); $event.stopPropagation()" />
      </ng-container>


      <!-- Size Dropdown -->
      <!-- <div class="size-dropdown" *ngIf="activeDropdownIndex === index">
        <ng-container *ngFor="let sizeOption of getAvailableSizes(index)">
          <button class="dropdown-item" (click)="changeWidgetSize(index, sizeOption.value)">
            {{ sizeOption.label }}
          </button>
        </ng-container>
      </div> -->
    </div>
  </div>

  <!-- Main Content -->
  <div class="expense-tracker__content">
    <div class="expense-tracker__viewport">
      <div class="expense-tracker__list"
        [style.transform]="'translateX(-' + (currentIndex * (100 / visibleItemsCount)) + '%)'">
        <div class="expense-item" *ngFor="let item of expenses" [style.flex]="'0 0 ' + (100 / visibleItemsCount) + '%'">
          <div class="expense-item__card">
            <div class="expense-item__icon-wrapper">
              <img [src]="item.icon" class="expense-item__icon" [alt]="item.label" />
            </div>

            <div class="expense-item__info">
              <div class="expense-item__label" [style.color]="item.color || '#ef4d6c'">
                {{ item.label }}
              </div>
              <div class="expense-item__amount">{{ item.amount }}</div>
              <div class="expense-item__period">
                <span>Over:</span>
                <span>{{ item.duration }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>